import { VoidPaymentStatusResponseDataType } from 'pages/ReconciliationReportPage/types';

export const voidVCCPaymentData: VoidPaymentStatusResponseDataType = {
  success: true,
  failureErrorMessage: '',
  documentId: '9482'
};

export const voidVCCPaymentErrorData: VoidPaymentStatusResponseDataType = {
  success: false,
  failureErrorMessage: 'DB failure',
  documentId: '9482'
};

export const voidVCCPaymentErrorsArray: VoidPaymentStatusResponseDataType = {
  success: false,
  failureErrorMessage: '',
  errors: ['error text'],
  documentId: '9482'
};
